import React from 'react';
// import { useGlobalContext } from '../context/GlobalContext';
import {
  FaLocationArrow,
  FaCalendarDay,
  FaClock,
  FaChild,
} from 'react-icons/fa';
import { GrYoga } from 'react-icons/gr';
import { TbYoga } from 'react-icons/tb';
import styled from 'styled-components';
import LessonInfo from './LessonInfo';

const Lesson = ({ date, duration, age, location, type, status }) => {
  // const { setEditLesson, deleteLesson } = useGlobalContext();
  const dateOptions = {
    weekday: 'long',
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hours: 'numeric',
    minutes: 'numeric',
    seconds: 'numeric',
    hour12: false,
  };
  let newDate = date.slice(0, 10);
  let newTime = date.slice(11, 19);

  let dateName = new Date(date).toLocaleDateString('nl-BE', {
    weekday: 'long',
  });
  let completeDate = dateName.concat(' ' + newDate + ' ' + newTime);

  return (
    <LessonContainer>
      <header>
        <div className='info'>
          <h2>
            <TbYoga color='#c99749' />
            {type}
          </h2>
        </div>
      </header>
      <div className='content'>
        <div className='content-center'>
          <LessonInfo
            icon={<FaCalendarDay />}
            text={completeDate}
            className='icon'
          />
          <LessonInfo icon={<FaClock />} text={duration} className='icon' />
          <LessonInfo icon={<FaChild />} text={age} className='icon' />
          <LessonInfo
            icon={<FaLocationArrow />}
            text={location.name}
            className='icon'
          />
          <LessonInfo
            icon={<FaLocationArrow />}
            text={location.address}
            className='icon'
          />
          <div className={`status ${status}`}>{status}</div>
          <br />
          <br />
        </div>
      </div>
      {/* <tr key={id}>
        <td>
          <Link to={`/lessen/${type}`} className=''>
            {type}
          </Link>
        </td>
        <td>{day}</td>
        <td>{date.slice(0, 10)}</td>
        <td>{date.slice(11, 19)}</td>
        <td>{duration}</td>
        <td>{age}</td>
        <td>{location.name}</td>
        <td>{location.address}</td>
      </tr> */}
      {/* <footer>
        <div className='actions'>
          <Link
            to='/addlesson'
            className='btn edit-btn'
            onClick={() => setEditLesson(_id)}
          >
            Edit
          </Link>
          <button
            type='button'
            className='btn delete-btn'
            onClick={() => deleteLesson(_id)}
          >
            Delete
          </button>
        </div>
      </footer> */}
    </LessonContainer>
  );
};

const LessonContainer = styled.article`
  background: var(--white);
  border-radius: var(--borderRadius);
  display: grid;
  grid-template-rows: 1fr auto;
  box-shadow: var(--shadow-2);
  h1,
  h2 {
    text-align: center;
    color: var(--primaryBtnColor);
  }
  header {
    padding: 1rem 1.5rem;
    border-bottom: 1px solid var(--grey-100);
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    h5 {
      letter-spacing: 0;
    }
  }
  .main-icon {
    width: 60px;
    height: 60px;
    display: grid;
    place-items: center;
    background: var(--primary-500);
    border-radius: var(--borderRadius);
    font-size: 1.5rem;
    font-weight: 700;
    text-transform: uppercase;
    color: var(--white);
    margin-right: 2rem;
  }
  .info {
    h2 {
      text-align: center;
      margin-bottom: 0.25rem;
    }
    p {
      margin: 0;
      text-transform: capitalize;
      color: var(--grey-400);
      letter-spacing: var(--letterSpacing);
    }
  }
  .pending {
    background: #fcefc7;
    color: #e9b949;
  }
  .interview {
    background: #e0e8f9;
    color: #647acb;
  }
  .declined {
    color: #d66a6a;
    background: #ffeeee;
  }
  .content {
    padding: 1rem 1.5rem;
  }
  .content-center {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 0.5rem;
    @media (min-width: 576px) {
      grid-template-columns: 1fr 1fr;
    }
    @media (min-width: 992px) {
      grid-template-columns: 1fr;
    }
    @media (min-width: 1120px) {
      grid-template-columns: 1fr 1fr;
    }
  }
  .status {
    border-radius: var(--borderRadius);
    text-transform: capitalize;
    letter-spacing: var(--letterSpacing);
    text-align: center;
    width: 100px;
    height: 30px;
  }
  footer {
    margin-top: 1rem;
  }
  .edit-btn,
  .delete-btn {
    letter-spacing: var(--letterSpacing);
    cursor: pointer;
    height: 30px;
  }
  .edit-btn {
    color: var(--green-dark);
    background: var(--green-light);
    margin-right: 0.5rem;
  }
  .delete-btn {
    color: var(--red-dark);
    background: var(--red-light);
  }
  &:hover .actions {
    visibility: visible;
  }
  .icon {
    color: var(--primaryBtnColor);
  }
`;

export default Lesson;
